import { persistProject } from "./helpers/persistProject";

export const setBlowCounts = (blowCounts) => {
  return persistProject({type: 'RECEIVED_NEW_BLOW_COUNTS', blowCounts});
}

export default {setBlowCounts};
